/** Live chat search on one Account (Workspace Search; OnlyFans or Fansly): debounced, the previous request aborted. */
import { useEffect, useState } from 'react';
import { searchChats, searchFanslyChats, type SearchHit } from './api';
import { useWorkspace } from './WorkspaceProvider';

export function useFanSearch(accountId: string | null, query: string) {
  const { accounts } = useWorkspace();
  const fansly = accounts.find((a) => a.account_id === accountId)?.platform.trim().toLowerCase() === 'fansly';
  const [hits, setHits] = useState<SearchHit[]>([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!query || !accountId) {
      setHits([]);
      setError(null);
      return;
    }
    const controller = new AbortController();
    const timer = window.setTimeout(() => {
      setBusy(true);
      (fansly ? searchFanslyChats : searchChats)(accountId, query, controller.signal)
        .then((h) => {
          setHits(h);
          setError(null);
        })
        .catch((err) => {
          if ((err as { name?: string }).name !== 'AbortError') setError((err as Error).message);
        })
        .finally(() => !controller.signal.aborted && setBusy(false));
    }, 350);
    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [query, accountId, fansly]);

  return { hits, busy, error };
}
